import React, { Component, createRef } from "react";
import { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Modal,
  Radio,
  Select,
  notification,
  Spin,
  Row,
  Col,
  Typography,
  Tag,
  Divider,
  Alert,
  Button,
  Result,
  Space,
  Descriptions,
  InputNumber,
  Card,
  Table,
  Tabs,
  Avatar,
  Statistic,
  Image
} from "antd";
import Apisetting from "../../api/Apisetting";
import Apiauth from "../../api/Apiauth";
import BankSelector from "../../screens/Bank/components/BankSelector";
import {
  FormatDataCustomerJson,
  FormatDataSettleSlip,
} from "../../helpers/formatDataJson";

import { tagsBageStatus, tagsColorAlert } from "../../helpers/tagsBage";
import { CopyTextToClipboard } from "../../helpers/copy";
import {
  BulbOutlined,
  CloseOutlined,
  CopyOutlined,
  InfoCircleOutlined,
  QuestionCircleTwoTone,
  UserAddOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import Apibank from "../../api/Apibank";
import Api from "../../api/Api";
import SelectedImage from "../SelectedImage";
import { CheckAdminType, CheckPermission } from "../../helpers/checkPermission";
import config from "../../config/app.config";
import {
  getCopyDetailMerchant,
  getDefaultDataRoleOwner,
  getSpecialDataRoleOwner,
  openNotification,
  renderValue,
  sendApiTelegram_activity,
  sendApiTelegram_activity_Support,
  sendApiTelegram_call_api_error,
  showToast,
  StringTimeLeft,
} from "../../utils";
import SelectedImageNew from "../selectedImageNew";
import moment from "moment";
import {
  calculateTimeDifference,
  FormatTimeAgo,
} from "../../helpers/formatTimeAgo";
import { getAlerIcon } from "../../helpers/getIcon";
import { DownloadOutlined } from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FormEditGeneralBankInfo } from "../../screens/Bank/components/FormEditGeneralBankInfo";
import { FormEditAdvancedBankInfo } from "../../screens/Bank/components/FormEditAdvancedBankInfo";
import { ChannelsBank, itemFormConfig, TypeOptions, ValidChannels } from "../../Data/FormConfig ";
import { iconTypeBank } from "../../screens/Bank/components/iconBank";
import { CONFIGMERCHENTID } from "../../Data/configMerchant";
import { getCookie } from "../../utils/cookieHelper";

import { LoginQRComponent } from "../Bank/componentQR";
import { Section1, Section3, Section4, Section5 } from "../txtLoginQR.js";


const { Title, Text } = Typography;
const { Timer } = Statistic;

const { confirm } = Modal;
// ************** Start of AddModel **************
export const AddModel = (params) => {
  if (params || params.show) {
    return (
      <>
        <Modal
          title="เพิ่มบัญชีธนาคารลูกค้า"
          open={params.show}
          onOk={params.onSubmit}
          onCancel={params.handleClose}
          width={800}
          style={{ top: 20 }}
          confirmLoading={params.isLoad}
          maskClosable={false}
          loading={false}
          okText={params.isLoad ? "loading..." : "เพิ่มบัญชีธนาคาร"}
          cancelText={"Canceled"}
          okButtonProps={{ autoFocus: true, htmlType: "submit" }}
          modalRender={(dom) => (
            <Form
              layout="vertical"
              form={params?.form}
              name="form_in_modal"
              initialValues={{ modifier: "public", username: "", password: "" }}
              clearOnDestroy
              onFinish={(values) => params.onCreate(values)}
              onFinishFailed={(errorInfo) => {
                console.log("Failed:", errorInfo);
              }}
              onValuesChange={(changedValues, allValues) => {
                console.log("changedValues", changedValues);
                console.log("allValues", allValues);
              }}
              onSubmit={(e) => {
                e.preventDefault();
                params.onSubmit(e);
              }}
            >
              {dom}
            </Form>
          )}
        >
          <hr />
          <Form.Item
            name="username"
            label="ชื่อ-นามสกุล"
            rules={[
              {
                required: true,
                message: "Please input the Name!",
              },
            ]}
          >
            <Input
              disabled={params.isLoad}
              type="text"
              placeholder="กรุณากรอกชื่อ-นามสกุล"
              name="username"
              onChange={params.onChangForm}
              autoFocus
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                max: 20,
                min: 6,
                message: "Please input the Password 6-20 characters!",
              },
            ]}
          >
            <Input
              disabled={params.isLoad}
              type="password"
              name="password"
              placeholder="กรุณากรอกรหัสผ่าน 6-20 ตัวอักษร"
              autoComplete="new-password"
              maxLength={20}
              minLength={6}
              onChange={params.onChangForm}
            />
          </Form.Item>
          <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          >
            <Radio.Group>
              <Radio value="public">Public</Radio>
              <Radio value="private">Private</Radio>
            </Radio.Group>
          </Form.Item>
          <Divider orientation="center">
            <small style={{ fontSize: "11px", color: "#888" }}>
              Version: {config.version}
            </small>
          </Divider>
        </Modal>
      </>
    );
  } else {
    return "";
  }
};
// ************** End of AddModel **************

// ************** Start of AddCustomerModel **************

export class AddCustomerModel extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      bank: null, // เปลี่ยนค่าเริ่มต้นเป็น null แทนที่จะเป็น string เปล่า
      bankList: [],
      // เพิ่ม state สำหรับ telephoneNumber (ถ้าจำเป็นต้องเก็บใน state นอกฟอร์ม)
      // แต่โดยปกติจะจัดการผ่าน Form.Item ใน onFormFinish
    };
  }

  // ใช้ componentDidUpdate เพื่อดึงข้อมูลเมื่อ Modal เปิด
  componentDidUpdate(prevProps) {
    const { show } = this.props;
    // ตรวจสอบว่า Modal เพิ่งถูกเปิด
    if (show && !prevProps.show) {
      // เมื่อ Modal เปิด ให้ดึงรายการธนาคาร
      this.fetchDataBankList();
    }
  }

  // ลบ componentDidMount เนื่องจากย้าย logic ไปที่ componentDidUpdate

  handleOk = () => {
    if (this.formRef.current) {
      // ส่งฟอร์มเพื่อเรียก onFormFinish หรือ onFormFinishFailed
      this.formRef.current.submit();
    }
  };

  onClose = () => {
    const { handleClose } = this.props;
    if (this.formRef.current && handleClose) {
      // รีเซ็ตฟิลด์ทั้งหมดในฟอร์ม
      this.formRef.current.resetFields();
      // รีเซ็ตค่า bank state ด้วย
      this.setState({ bank: null });
      handleClose();
    }
  };

  fetchDataBankList = async () => {
    try {
      const res = await Apisetting.getall_bankinfo();
      if (res?.data?.success) {
        this.setState({ bankList: res?.data?.data });
      } else {
        notification.error({
          message: "Error",
          description: res?.data?.message,
        });
      }
    } catch (error) {
      console.error("Failed to fetch bank list:", error);
      notification.error({
        message: "Error",
        description: error.message,
      });
    }
  };

  /**
   * @param {Object} values - An object containing the validated form field values.
   */
  onFormFinish = async (values) => {
    const { fetchData } = this.props;
    const { bank } = this.state;
    // ดึงค่า account, name, และ telephoneNumber จาก values
    const { account, name, telephoneNumber } = values;

    // ใช้ค่า bank จาก state
    if (!bank || bank === "-- เลือกธนาคาร --") {
      notification.error({
        message: "Error",
        description: `กรุณาเลือกบัญชีธนาคาร!`,
      });
      return;
    }

    let item = {
      bankAccountNumber: account,
      bank_id: bank, // ใช้ค่า bank_id ที่เก็บไว้ใน state
      bankAccountName: name,
      telephoneNumber: telephoneNumber, // เพิ่ม telephoneNumber ใน payload
    };
    const { resProfileAdmin } = this.props;

    //
    let isName = `${item?.bank_id}, ${item?.bankAccountNumber}, ${item?.bankAccountName}`;
    const details = `Add Customer : ${isName}`;

    this.setState({ loading: true });
    try {
      const res = await Apiauth.addCustomer(item);
      sendApiTelegram_activity(res, "Add Customer", details, resProfileAdmin);
      if (res.data.success) {
        setTimeout(() => {
          notification.success({
            message: "Success",
            description: res.data.message,
          });
          this.onClose();
          fetchData();
        }, 1500);
      } else {
        notification.error({
          message: "Error",
          description: res.data.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message,
      });
      sendApiTelegram_call_api_error(error, "Add Customer");
    } finally {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1500);
    }
  };

  /**
   * @param {Object | Array} errorInfo
   */
  onFormFinishFailed = (errorInfo) => {
    let errArr = Array.isArray(errorInfo.errorFields)
      ? errorInfo.errorFields
      : [];
    if (errArr.length >= 1) {
      const firstError = errArr[0];
      const fieldName = firstError.name.join(".");
      const errorMessage = firstError.errors[0];

      notification.error({
        message: "การส่งฟอร์มล้มเหลว",
        description: `เกิดข้อผิดพลาดในฟิลด์ '${fieldName}': ${errorMessage}`,
        duration: 4,
      });
    }
  };

  /**
   * @param {Object} changedValues
   * @param {Object} allValues
   */
  onFormValuesChange = (changedValues, allValues) => {
    // โค้ดเดิม
    if (this.props.onChangForm) {
      this.props.onChangForm(changedValues, allValues);
    }
  };

  /**
   * @param {Object} bank - object ที่มาจากการเลือกใน SelectedImageNew
   */
  onChangBank = (bank) => {
    if (bank) {
      // ตรวจสอบว่า bank มี bank_id หรือไม่ก่อนที่จะอัปเดต state
      this.setState({ bank: bank?.bank_id || null });
    } else {
      this.setState({ bank: null });
    }
  };

  render() {
    const { show, t } = this.props;
    const { loading } = this.state;
    return (
      <Modal
        title={t("Add a Customer's Bank")}
        open={show}
        onOk={this.handleOk}
        onCancel={this.onClose}
        maskClosable={false}
        width={500}
        style={{ top: 20 }}
        confirmLoading={loading}
        okText={loading ? "loading..." : t("confirm")}
        cancelText={t("Canceled")}
        okButtonProps={{ autoFocus: true, htmlType: "submit" }}
      >
        <hr className="my-4 border-gray-200" />
        <Form
          ref={this.formRef}
          layout="vertical"
          name="customer_bank_account_form"
          // ลบ bank ออกจาก initialValues เพื่อให้จัดการด้วย SelectedImageNew/onChangBank
          initialValues={{ name: "", account: "", telephoneNumber: "" }}
          onFinish={this.onFormFinish}
          onFinishFailed={this.onFormFinishFailed}
          onValuesChange={this.onFormValuesChange}
        >
          {/* Form Item for Bank Selection (Component ภายนอก) */}
          <Form.Item
            name="bank_selection" // เปลี่ยน name เพื่อหลีกเลี่ยงความสับสนกับ state/payload
            label={t("Bank")}
            rules={[
              {
                required: false, // การตรวจสอบจะทำใน onFormFinish แทน
                message: "This field is required!",
              },
            ]}
          >
            <SelectedImageNew onChangBank={this.onChangBank} />
          </Form.Item>

          {/* Form Item for Account Name */}
          <Form.Item
            name="name"
            label={t("Account name")}
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
            ]}
          >
            <Input disabled={loading} placeholder="กรอกชื่อ-นามสกุล" />
          </Form.Item>

          {/* Form Item for Account Number */}
          <Form.Item
            name="account"
            label={t("Account number")}
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
              {
                pattern: /^\d+$/,
                message: "เลขบัญชีธนาคารต้องเป็นตัวเลขเท่านั้น",
              },
              {
                min: 10,
                max: 15,
                message: "เลขบัญชีต้องมีความยาวระหว่าง 10 ถึง 15 หลัก",
              },
            ]}
          >
            <Input
              width={"100%"}
              type="text"
              disabled={loading}
              placeholder="กรอกเลขบัญชี"
            />
          </Form.Item>

          {/* 🌟 New Form Item for Telephone Number 🌟 */}
          <Form.Item
            name="telephoneNumber"
            label={t("Telephone Number")}
            rules={[
              {
                required: true,
                message: "This field is required!",
              },
              {
                pattern: /^\d{9,10}$/, // รูปแบบเบอร์โทรศัพท์ 9 หรือ 10 หลักที่เป็นตัวเลข
                message: "เบอร์โทรศัพท์ต้องเป็นตัวเลข 9 หรือ 10 หลักเท่านั้น",
              },
            ]}
          >
            <Input
              width={"100%"}
              type="tel"
              disabled={loading}
              placeholder="กรอกเบอร์โทรศัพท์"
              maxLength={10}
            />
          </Form.Item>
        </Form>
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************** End of AddCustomerModel **************

// ************** Start of ModelDetailWithdraw **************
export class ModelDetailWithdraw extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  onCloseModel = () => {
    this.props.handleClose();
  };

  render() {
    const { show, t, isData, nameMerchang } = this.props;
    const { loading } = this.state;

    if (!show) {
      return null;
    }
    const isRecipient = FormatDataCustomerJson(isData?.bank);
    const isSettleSlip = FormatDataSettleSlip(isData?.settleSlip);
    const settleSlipStatus = isSettleSlip?.status;
    const note = isData?.note;
    // const submittedDateTime = isSettleSlip?.submittedDateTime || null;
    const updatedDateTime = isData?.transactionDateTime || isData?.updated_at;
    let transactionDateTime = isData?.transactionDateTime === null;
    let created_at = isData?.created_at;
    let updated_at = isData?.updated_at;
    const message = isSettleSlip?.message;
    const error = isSettleSlip?.error;
    const fee = Intl.NumberFormat().format(
      parseFloat(isData?.transferAmount - isData?.amount).toFixed(2),
    );
    const settleAmt = Intl.NumberFormat().format(
      parseFloat(isData?.settleAmount).toFixed(2),
    );

    const status = isData?.status;
    const isRejected = status === "REJECTED";
    const isProcessing = status === "PROCESSING";
    const isInQueue = status === "IN_QUEUE";
    const isInQMANUAL = status === "INQ_MANUAL";
    const isSuccess = status === "SUCCESS";
    const isPending = status === "PENDING";
    const isVerify = status === "VERRIFY_FAILED";
    let successToTime = isSuccess
      ? calculateTimeDifference(created_at, updatedDateTime)
      : FormatTimeAgo(updated_at);

    // 2. สร้าง Object Map สำหรับ Alert Type
    const alertType = isRejected
      ? "error"
      : isSuccess
        ? "success"
        : isProcessing
          ? "info"
          : isPending
            ? "warning"
            : isInQMANUAL
              ? "cyan"
              : isVerify
                ? "geekblue"
                : isInQueue
                  ? "purple"
                  : "info";
    const isNote = isRejected ? note : error || "Transaction  Rejected";
    const AlertMessage = () => {
      if (settleSlipStatus) {
        const finalMessage = message ? message : t("Transaction successful");
        return (
          <span
            style={{
              color: tagsColorAlert(alertType),
              fontWeight: "600",
            }}
          >{`${status} : ${isRejected ? isNote : finalMessage}`}</span>
        );
      }
      let content;
      if (isRejected) {
        content = error || t("Transaction rejected");
      } else if (isProcessing) {
        content = error || t("อยู่ระหว่างตรวจสอบรายการ...");
      } else if (isInQueue) {
        content = error || t("อยู่ในคิวดำเนินการ...");
      } else if (isInQMANUAL) {
        content = error || t("อยู่ในคิวดำเนินการ ถอนมือ...");
      } else if (isPending) {
        content = error || t("กำลังรอการประมวลผล...");
      } else if (isSuccess) {
        content = t("Transaction successful...");
      } else if (isVerify) {
        content = t("เกิดข้อผิดพลาดระหว่างเชื่อมต่อธนาคาร...");
      } else {
        content = (
          <span>
            {t("Unknown status")} ({status})
          </span>
        );
      }
      const statusText = (
        <span
          style={{
            color: tagsColorAlert(alertType),
            fontWeight: "600",
          }}
        >
          {status} : {content}
        </span>
      );

      return <>{statusText}</>;
    };

    // **********************************************
    let formatDate = "YYYY-MM-DD HH:mm:ss";
    let columnProps = {
      xxl: 1,
      xl: 1,
      lg: 1,
      md: 1,
      sm: 1,
      xs: 1,
    };
    return (
      <>
        <Modal
          maskClosable={false}
          title={
            <h4 className="mb-4 fs-sm-20" style={{ color: "#606060" }}>
              {t(`Payout Details`)}
            </h4>
          }
          open={show}
          width={800}
          closable={false}
          style={{ top: 20 }}
          confirmLoading={loading}
          footer={[
            <Button key="close" onClick={() => this.onCloseModel()}>
              {t("close")}
            </Button>,
          ]}
        >
          {/* Main Detail */}
          <Alert
            showIcon
            icon={getAlerIcon(status)}
            className="mb-3 fs-sm-10 fs-14"
            type={alertType}

            message={<AlertMessage />}
          />
          <>
            <>
              {/* ************** เริ่มใช้ Descriptions ************** */}
              <Descriptions
                span={12}
                size="small"
                bordered
                column={columnProps}
              >
                {/* ID */}
                <Descriptions.Item label={t("ID")}>
                  {renderValue(
                    t("ID"),
                    isData?.id,
                    false,
                    t,
                    CopyTextToClipboard, // ต้องมีฟังก์ชันนี้ใน skope
                  )}
                </Descriptions.Item>
                {/* log Uuid */}
                <Descriptions.Item label={t("Ref")}>
                  {renderValue(
                    t("LOG UUID"),
                    isData?.logUuid,
                    false,
                    t,
                    CopyTextToClipboard, // ต้องมีฟังก์ชันนี้ใน skope
                  )}
                </Descriptions.Item>

                {/* merchantOrderId */}
                <Descriptions.Item label={t("merchantOrderId")}>
                  {renderValue(
                    t("merchantOrderId"),
                    isData?.referenceId,
                    false,
                    t,
                    CopyTextToClipboard,
                  )}
                </Descriptions.Item>

                {/* platformOrderId */}
                <Descriptions.Item label={t("PlatformOrderID")}>
                  {renderValue(
                    t("PlatformOrderID"),
                    isData?.platformOrderId,
                    false,
                    t,
                    CopyTextToClipboard,
                  )}
                </Descriptions.Item>

                {/* merchant Name */}
                <Descriptions.Item label={t("Merchant")}>
                  {renderValue(t("merchant"), nameMerchang, false, t)}
                </Descriptions.Item>

                {/* merchant id */}
                <Descriptions.Item label={t("Merchant ID")}>
                  {renderValue(t("Merchant ID"), isData?.merchantId, false, t)}
                </Descriptions.Item>

                {/* Type */}
                <Descriptions.Item label={t("Type")}>
                  {/* ไม่ต้องใส่ onCopy เพราะ Type เป็น Tag */}
                  {renderValue("Type", isData?.type, false, t)}
                </Descriptions.Item>

                {/* Withdraw Amt. */}
                <Descriptions.Item label={t("withdraw amt")}>
                  {renderValue(t("Withdraw Amt."), isData?.amount, true, t)}
                </Descriptions.Item>
                {/* Withdraw Amt. */}
                <Descriptions.Item label={t("tarnsfer amt")}>
                  {renderValue(
                    t("transferAmount"),
                    isData?.transferAmount,
                    true,
                    t,
                  )}
                </Descriptions.Item>

                {/* settleAmount */}
                <Descriptions.Item label={t("deduction credit")}>
                  {renderValue(
                    t("deduction credit"),
                    <Text delete={!isSuccess}>
                      <div className="fs-sm-11" style={{ fontSize: "14px" }}>
                        {settleAmt}.-
                      </div>
                    </Text>,
                    true,
                    t,
                  )}
                </Descriptions.Item>
                {/* Fee */}
                <Descriptions.Item label={t("fee")}>
                  {renderValue(
                    "Fee",
                    <Text delete={!isSuccess}>
                      <div className="fs-sm-11" style={{ fontSize: "14px" }}>
                        {fee}.-
                      </div>
                    </Text>,
                    true,
                    t,
                  )}
                </Descriptions.Item>
                {/* currency */}
                <Descriptions.Item label={t("Currency")}>
                  {renderValue(t("Currency"), isData?.currency, false, t)}
                </Descriptions.Item>

                {/* CREATED DATE */}
                <Descriptions.Item label={t("CREATED DATE")}>
                  {renderValue(
                    "CREATED DATE",
                    moment(isData?.created_at).format(formatDate),
                    false,
                    t,
                  )}
                </Descriptions.Item>

                {updatedDateTime ? (
                  <>
                    {/* SUCCESS TIME */}
                    <Descriptions.Item label={<>{t("SUCCESS TIME")}</>}>
                      {renderValue(
                        "SUCCESS TIME",
                        <>
                          {isSuccess
                            ? moment(updatedDateTime).format(formatDate)
                            : "-"}
                        </>,
                        false,
                        t,
                      )}
                    </Descriptions.Item>
                  </>
                ) : null}

                {/* COMPLETION TIME */}
                <Descriptions.Item label={t("COMPLETION TIME")}>
                  {updatedDateTime
                    ? renderValue(
                      "COMPLETION TIME",
                      isSuccess ? successToTime : "-",
                      false,
                      t,
                    )
                    : "-"}
                </Descriptions.Item>

                {/* Status */}
                <Descriptions.Item label={t("status")}>
                  {renderValue("Status", isData?.status, false, t)}
                </Descriptions.Item>

                {/* Note (ใช้ span 2 columns เพื่อให้เนื้อหาเต็ม) */}
                {isData?.updatedBy ? (
                  <>
                    <Descriptions.Item label={t("updatedBy")} span={2}>
                      {renderValue(
                        t("updatedBy"),
                        isData?.updatedBy || "-",
                        false,
                        t,
                      )}
                    </Descriptions.Item>
                  </>
                ) : null}

                {/* Note (ใช้ span 2 columns เพื่อให้เนื้อหาเต็ม) */}
                <Descriptions.Item label={t("remark")} span={2}>
                  {renderValue(
                    t("remark"),
                    t(isData?.note) +
                    `${transactionDateTime && isSuccess ? ` (${t("WithdrawalManual")})` : ""}`,
                    false,
                    t,
                  )}
                </Descriptions.Item>

                {/* ************************ */}
                {/* From Bank Section */}
                {isSettleSlip?.status && (
                  <Descriptions.Item
                    style={{ background: "#d4d4d44f" }}
                    span={2}
                  >
                    <UserDeleteOutlined
                      style={{
                        fontSize: "16px",
                        marginRight: "5px",
                      }}
                    />
                    <span
                      className="fs-sm-13"
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                        color: "#5a5a5a",
                      }}
                    >
                      {t("From bank account")}
                    </span>
                  </Descriptions.Item>
                )}

                {isSettleSlip?.status && (
                  <>
                    {/* From account name Th */}
                    <Descriptions.Item
                      label={t("From account name Th")}
                      className="text-truncate "
                    >
                      {renderValue(
                        t("From account name Th"),
                        isSettleSlip?.data?.fromAccountNameTh,
                        false,
                        t,
                      )}
                    </Descriptions.Item>

                    {/* From account name En */}
                    <Descriptions.Item
                      label={t("From account name En")}
                      className="text-truncate"
                    >
                      {renderValue(
                        t("From account name En"),
                        isSettleSlip?.data?.fromAccountNameEn,
                        false,
                        t,
                      )}
                    </Descriptions.Item>

                    {/* from account Number */}
                    <Descriptions.Item
                      label={t("Account No.")}
                      className="text-truncate"
                    >
                      {renderValue(
                        t("from account Number"),
                        isSettleSlip?.data?.fromAccountNo,
                        false,
                        t,
                        CopyTextToClipboard,
                      )}
                    </Descriptions.Item>
                  </>
                )}

                {/* ************Recipient************ */}
                {/* Recipient account */}
                <Descriptions.Item style={{ background: "#d4d4d44f" }} span={2}>
                  <UserAddOutlined
                    style={{
                      fontSize: "16px",
                      marginRight: "5px",
                    }}
                  />
                  {isSettleSlip?.status ? (
                    <span
                      className="fs-sm-13"
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                        color: "#5a5a5a",
                      }}
                    >
                      {t("Customer Account")}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontWeight: "600",
                        fontSize: "16px",
                        color: "#5a5a5a",
                      }}
                    >
                      {t("Customer Account")}
                    </span>
                  )}
                </Descriptions.Item>

                {/* Costomer UUID */}
                <Descriptions.Item label={t("UUID")}>
                  {renderValue(
                    t("Customer UUID"),
                    isData?.customer,
                    false,
                    t,
                    CopyTextToClipboard,
                  )}
                </Descriptions.Item>

                {/* Bank */}
                <Descriptions.Item label={t("Bank")}>
                  {renderValue("Bank", isRecipient?.bankCode, false, t)}
                </Descriptions.Item>

                {/* Account name */}
                <Descriptions.Item label={t("Name")}>
                  {renderValue(
                    t("Account name"),
                    isRecipient?.accountName,
                    false,
                    t,
                    CopyTextToClipboard,
                  )}
                </Descriptions.Item>

                {/* Account number */}
                <Descriptions.Item label={t("Account No.")}>
                  {renderValue(
                    t("Account number"),
                    isRecipient?.accountNo,
                    false,
                    t,
                    CopyTextToClipboard,
                  )}
                </Descriptions.Item>
              </Descriptions>
              {/* ************** สิ้นสุดการใช้ Descriptions ************** */}
            </>
          </>
          <Divider>
            <p className="text-center text-mute">
              <small style={{ color: "#888", fontSize: "11px" }}>
                Version: {config.version}
              </small>
            </p>
          </Divider>
        </Modal>
      </>
    );
  }
}
// ************** Start of EditCustomerModel **************

export const EditCustomerModel = ({
  show,
  t,
  handleClose,
  fetchData,
  isData,
  tokenMerchant,
  resProfileAdmin,
}) => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef();
  const [bankId, setBankId] = useState("");
  useEffect(() => {
    if (formRef.current && isData) {
      formRef.current.setFieldsValue({
        name: isData?.name || "",
        account: isData?.account_no || "",
        telephoneNumber: isData?.telephoneNumber || "",
        bank: isData?.bank_code || "-- เลือกธนาคาร --",
      });
      setBankId(isData?.bank_code);
    }
  }, [isData]);

  const onFormFinish = async (values) => {
    // 1. Validation เบื้องต้น
    if (!bankId || bankId === "-- เลือกธนาคาร --") {
      notification.error({
        message: "Error",
        description: "กรุณาเลือกบัญชีธนาคาร!",
      });
      return;
    }

    setLoading(true);

    const customerUuid = isData?.customer_uuid;
    const isName = `${bankId}, ${values?.account}, ${values?.name}`;
    const details = `Edit Customer Info : ${isName}`;

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${tokenMerchant}`);

      const raw = JSON.stringify({
        account_no: values.account,
        name: values.name,
        telephoneNumber: values.telephoneNumber,
        bankId: bankId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
      };

      const endpoint = `${config.apiURL}/api/v2/merchans/editCustumer/${customerUuid}`;
      const response = await fetch(endpoint, requestOptions);

      // 2. ตรวจสอบ HTTP Status (เช่น 401, 404, 500)
      if (!response.ok) {
        const httpError = {
          message: `HTTP error! status: ${response.status}`,
          status: response.status,
        };
        if (typeof sendApiTelegram_call_api_error === "function") {
          sendApiTelegram_call_api_error(
            httpError,
            "Edit Customer (HTTP Error)",
          );
        }
        throw new Error(`Server Error: ${response.status}`);
      }

      const apiResult = await response.json();

      if (typeof sendApiTelegram_activity === "function") {
        const logPayload = {
          message: apiResult.message || "แก้ไขข้อมูลสำเร็จ",
          status: response.status,
          success: apiResult.success,
        };
        sendApiTelegram_activity(
          logPayload,
          "Edit Customer",
          details,
          resProfileAdmin,
        );
      }

      if (apiResult.success) {
        notification.success({
          message: "Success",
          description: apiResult.message || "แก้ไขข้อมูลสำเร็จ",
        });
        setTimeout(() => {
          handleClose();
          if (typeof fetchData === "function") fetchData();
        }, 1500);
      } else {
        notification.error({
          message: "Error",
          description: apiResult.message || "แก้ไขข้อมูลไม่สำเร็จ",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      if (typeof sendApiTelegram_call_api_error === "function") {
        sendApiTelegram_call_api_error(error, "Edit Customer (Catch Error)");
      }
      notification.error({
        message: "เกิดข้อผิดพลาดในการแก้ไข",
        description: error.message || "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
      });
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  };

  const onFormFinishFailed = (errorInfo) => {
    if (errorInfo.errorFields && errorInfo.errorFields.length >= 1) {
      const firstError = errorInfo.errorFields[0];
      const fieldName = firstError.name.join(".");
      const errorMessage = firstError.errors[0];

      console.error("Form submission failed due to validation:", errorInfo);

      notification.error({
        message: "การส่งฟอร์มล้มเหลว",
        description: `กรุณาแก้ไขข้อผิดพลาดในฟิลด์ '${fieldName}': ${errorMessage}`,
        duration: 4,
      });
    } else {
      console.log("Form submission failed due to validation:", errorInfo);
    }
  };

  const onChangBank = (bank) => {
    if (bank) {
      setBankId(bank?.bank_id);
    }
  };

  const onHandleClose = () => {
    if (formRef.current) {
      formRef.current.resetFields();
    }
    handleClose();
  };

  return (
    <Modal
      title={t("Edit a Customer's Bank")}
      open={show}
      maskClosable={false}
      onOk={() => formRef.current?.submit()}
      onCancel={onHandleClose}
      width={500}
      style={{ top: 20 }}
      confirmLoading={loading}
      okText={loading ? "loading..." : t("save")}
      cancelText={t("Canceled")}
      okButtonProps={{ autoFocus: true, htmlType: "submit" }}
    >
      <hr className="my-4 border-gray-200" />
      <Form
        ref={formRef}
        layout="vertical"
        name="customer_bank_account_form"
        onFinish={onFormFinish}
        onFinishFailed={onFormFinishFailed}
      >
        <Form.Item
          name="bank"
          label={t("Bank")}
          rules={[{ required: true, message: "This field is required!" }]}
        >
          <SelectedImage
            onChangBank={onChangBank}
            bankId={bankId}
            defaultValue={isData}
          />
        </Form.Item>
        <Form.Item
          name="name"
          label={t("Account name")}
          rules={[{ required: true, message: "This field is required!" }]}
        >
          <Input disabled={loading} placeholder="กรอกชื่อ-นามสกุล" />
        </Form.Item>
        <Form.Item
          name="account"
          label={t("Account number")}
          rules={[
            {
              required: true,
              message: "This field is required!",
            },
            {
              // Rule: ตรวจสอบว่าเป็นตัวเลขเท่านั้น
              pattern: /^\d+$/,
              message: "เลขบัญชีธนาคารต้องเป็นตัวเลขเท่านั้น",
            },
            {
              // Rule: ตรวจสอบความยาว (ปรับค่า min/max ตามความเหมาะสม)
              min: 10,
              max: 15,
              message: "เลขบัญชีต้องมีความยาวระหว่าง 10 ถึง 15 หลัก",
            },
          ]}
        >
          <Input disabled={loading} placeholder="กรอกเลขบัญชี" type="text" />
        </Form.Item>
        <Form.Item
          name="telephoneNumber"
          label={t("Telephone Number")} // อาจต้องใช้ t("telephone_number") ถ้ามีการแปล
          rules={[
            { required: true, message: "This field is required!" },
            {
              // Rule: ตรวจสอบว่าเป็นตัวเลข 10 หลัก (เบอร์โทรศัพท์มือถือไทยทั่วไป)
              pattern: /^\d{10}$/,
              message: "เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลักเท่านั้น",
            },
          ]}
        >
          <Input disabled={loading} placeholder="กรุณากรอกเบอร์โทรศัพท์" />
        </Form.Item>
      </Form>
      <Divider orientation="center">
        <small style={{ fontSize: "11px", color: "#888" }}>
          Version: {config.version}
        </small>
      </Divider>
    </Modal>
  );
};
// ************** End of EditCustomerModel **************
// ************** Start of AddMerchantModal **************

export class AddMerchantModal extends Component {
  formRef = React.createRef();
  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitting: false,
      showCopyAlert: false,
      txtCopy: "",
      newMerchant: "",
    };
  }

  openNotification = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  displayTime = (seconds) => {
    let close = document.getElementById("close");
    let show = document.getElementById("show");
    if (close === "0") {
      setTimeout(() => {
        show.style.display = "none";
      }, 30000);
    }
    if (close && show) {
      close.innerText = `${seconds}s`;
    }
  };

  showConfirm = (res, merchantName) => {
    confirm({
      width: 500,
      icon: <></>,
      style: { top: 20 },
      content: (
        <>
          <Result
            status="success"
            title="Successfully"
            subTitle={
              <>
                <br />
                <Input
                  id="input-sm"
                  className="input-sm-100 mb-3"
                  style={{ width: "100%" }}
                  addonBefore="URL LOGIN"
                  value={window.location.origin + "/#login"}
                  readOnly
                  addonAfter={
                    <CopyOutlined
                      onClick={() =>
                        CopyTextToClipboard(window.location.origin + "/#login")
                      }
                    />
                  }
                />

                <Input
                  id="input-sm"
                  addonBefore="USERNAME"
                  className="input-sm-100 mb-3"
                  readOnly
                  value={res?.username || ""}
                  style={{ width: "100%" }}
                  addonAfter={
                    <CopyOutlined
                      onClick={() => CopyTextToClipboard(res?.username || "")}
                    />
                  }
                />
                <Input
                  id="input-sm"
                  className="input-sm-100 mb-3"
                  addonBefore="PASSWORD"
                  readOnly
                  value={res?.password || ""}
                  style={{ width: "100%" }}
                  addonAfter={
                    <CopyOutlined
                      onClick={() => CopyTextToClipboard(res?.password || "")}
                    />
                  }
                /> 
                <br />
                <Button type="primary" onClick={() => getCopyDetailMerchant(res, merchantName)}>Copy detail</Button>
                <Space className="mt-3 mb-3" direction="vertical"></Space>
              </>
            }
          />
        </>
      ),
    });
  };

  onFinish = async (values) => {
    this.setState({ submitting: true });
    const { getAllDataMerchang, permissionData } = this.props;
    let special = ['programer', 'superadmin', 'agent']

    let defaultDataOwnerRole = getDefaultDataRoleOwner(permissionData);
    let specialDataRoleOwner = getSpecialDataRoleOwner(permissionData);
    if (values?.merchant?.admin_type === "admin" && defaultDataOwnerRole.length === 0) {
      this.openNotification("error", "Error", "ไม่พบข้อมูล Default role Data ในระบบ",);
      this.setState({ submitting: false });
      return;
    }
    if (special.includes(values?.merchant?.admin_type) && specialDataRoleOwner.length === 0) {
      console.log("specialDataRoleOwner", specialDataRoleOwner);
      this.openNotification("error", "Error", "ไม่พบข้อมูล Special role Data ในระบบ",);
      this.setState({ submitting: false });
      return;
    }
    // ดึงค่า roleType จาก Select มาใช้งาน (ถ้ามี)
    let role = {
      name: values.merchant.name,
      permission: special.includes(values?.merchant?.admin_type) ? specialDataRoleOwner : defaultDataOwnerRole,
      roleName: `${values.merchant.name} Owner`,
    };

    let postData = {
      depositCallbackUrl:
        values?.merchant?.depositCallbackUrl ||
        "https://YOUR_PAYIN_CALLBACK_URL.com",
      withdrawalCallbackUrl:
        values?.merchant?.withdrawalCallbackUrl ||
        "https://YOUR_PAYOUT_CALLBACK_URL.com",
      depositOnHoldCallbackUrl:
        values?.merchant?.depositOnHoldCallbackUrl ||
        "https://YOUR_OnHold_CALLBACK_URL.com",
      name: values.merchant.name,
      deposit_minlimit: 1,
      witdrow_minlimit: 1,
      withdrawalLimit: 10000,
      withdrawStrategy: 100000,
      maximumWithdrawVolumePerBankAccount: 100000,
      maximumWithdrawTxsPerBankAccount: 1000000,
      role,
      admin_type: values?.merchant?.admin_type || "admin", // เพิ่มค่าที่ได้จาก admin_type
    };

    this.setState({newMerchant: values.merchant.name})

    try {
      Apiauth.addMerchant(postData)
        .then((res) => {
          if (res.data.success) {
            getAllDataMerchang();
            this.openNotification("success", "successfully", res.data.message);
            setTimeout(() => {
              this.onCloseModal();
              this?.formRef?.current?.resetFields();
              this.showConfirm(res.data.useradmin, this.state.newMerchant);
              this.setState({
                submitting: false,
              });
            }, 1500);
          } else {
            setTimeout(() => {
              this.setState({
                submitting: false,
              });
            }, 1500);
            this.openNotification(
              "error",
              `error: ${res.status}`,
              res.data.message,
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.openNotification(
            "error",
            `catch err: ${err.status}`,
            err.message,
          );
        });
    } catch (error) {
      console.error("Failed to add merchant:", error);
      this.openNotification(
        "error",
        `catch error: ${error?.status}`,
        error.message,
      );
    } finally {
      setTimeout(() => {
        this.setState({
          loading: false,
          submitting: false,
        });
      }, 2000);
    }
  };

  onCloseModal = () => {
    this?.props?.handleClose();
  };

  render() {
    const { show, t } = this.props;
    const { submitting } = this.state;

    if (!show) {
      return "";
    }

    const validateMessages = {
      required: `${t("This field is required")}`,
      types: {
        email: `${t("Not a valid email")}`,
        number: `${t("Not a valid number")}`,
      },
      number: {
        range: `${t("Must be between")} \${min} ${t("and")} \${max}`,
      },
    };

    const check = CheckAdminType("selectTypeAdmin");

    return (
      <Modal
        maskClosable={false}
        title={
          <Title level={4} className="mb-4">
            {t(`Add Merchant`)}
          </Title>
        }
        open={show}
        onOk={() => this.formRef.current.submit()}
        onCancel={this.onCloseModal}
        width={500}
        style={{ top: 20 }}
        confirmLoading={submitting}
        okText={t("Add Merchant")}
        cancelText={t("Cancel")}
      >
        <Spin
          spinning={submitting}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          <Row gutter={[8, 0]}>
            <Form
              ref={this.formRef}
              name="add-merchant-form"
              style={{ width: "100%", textTransform: "uppercase" }}
              layout="vertical"
              onFinish={this.onFinish}
              validateMessages={validateMessages}
            >
              {/* Merchant Name */}
              <Col span={24}>
                <Form.Item
                  name={["merchant", "name"]}
                  label={t("Merchant Name")}
                  rules={[
                    {
                      required: true,
                      message: t("Please input the merchant name!"),
                    },
                  ]}
                >
                  <Input placeholder={"Enter merchant name"} />
                </Form.Item>
              </Col>

              {/* Role Select (เพิ่มใหม่) */}
              {check && (
                <Col span={24}>
                  <Form.Item
                    name={["merchant", "admin_type"]}
                    label={t("Admin Type")}
                    rules={[
                      {
                        required: false,
                        message: t("Please select a role!"),
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select a admin type"
                      defaultValue={"admin"}
                      options={[
                        { value: "admin", label: "admin" },
                        { value: "superadmin", label: "superadmin" },
                        { value: "programer", label: "programer" },
                        { value: "agent", label: "agent" },
                      ]}
                    />
                  </Form.Item>
                </Col>
              )}

              {/* Payin CallbackUrl */}
              <Col span={24}>
                <Form.Item
                  name={["merchant", "depositCallbackUrl"]}
                  label={t("Dep. CallbackUrl")}
                >
                  <Input
                    defaultValue={"https://YOUR_PAYIN_CALLBACK_URL.com"}
                    style={{ textTransform: "lowercase" }}
                    placeholder={"Enter deposit Callback Url"}
                  />
                </Form.Item>
              </Col>

              {/* Payout CallbackUrl */}
              <Col span={24}>
                <Form.Item
                  name={["merchant", "withdrawalCallbackUrl"]}
                  label={t("Wth. CallbackUrl")}
                >
                  <Input
                    defaultValue={"https://YOUR_PAYOUT_CALLBACK_URL.com"}
                    style={{ textTransform: "lowercase" }}
                    placeholder={"Enter withdraw Callback Url"}
                  />
                </Form.Item>
              </Col>
              {/* OnHold CallbackUrl */}
              <Col span={24}>
                <Form.Item
                  name={["merchant", "depositOnHoldCallbackUrl"]}
                  label={t("OnHold CallbackUrl")}
                >
                  <Input
                    defaultValue={"https://YOUR_OnHold_CALLBACK_URL.com"}
                    style={{ textTransform: "lowercase" }}
                    placeholder={"Enter OnHold Callback Url"}
                  />
                </Form.Item>
              </Col>
              <br />
            </Form>
          </Row>
        </Spin>
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************** End of AddMerchantModal **************

// ************** Start of ModelSettle **************
export class ModelSettle extends Component {
  formRef = React.createRef();
  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  state = {
    loading: false,
    submitting: false,
  };
  openNotification = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };
  onFinish = async (values) => {
    this.setState({ submitting: true });
    try {
      Apiauth.addMerchant(values.merchant)
        .then((res) => {
          if (res.data.success) {
            this.props.handleClose();
            this.formRef.current.resetFields();
            this.openNotification("success", "successfully", res.data.message);
          } else {
            this.openNotification(
              "error",
              `error: ${res.status}`,
              res.data.message,
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.openNotification(
            "error",
            `catch err: ${err.status}`,
            err.message,
          );
        });
    } catch (error) {
      console.error("Failed to add merchant:", error);
      this.openNotification(
        "error",
        `catch error: ${error?.status}`,
        error.message,
      );
    } finally {
      this.setState({ submitting: false });
    }
  };
  onCloseModal = () => {
    this.props.handleClose();
    this.formRef.current.resetFields();
  };
  render() {
    const { show, t } = this.props;
    const { submitting } = this.state;

    if (!show) {
      return "";
    }
    const validateMessages = {
      required: `${t("This field is required")}`,
      types: {
        email: `${t("Not a valid email")}`,
        number: `${t("Not a valid number")}`,
      },
      number: {
        range: `${t("Must be between")} \${min} ${t("and")} \${max}`,
      },
    };
    return (
      <Modal
        title={
          <Title level={4} className="mb-4">
            {/* <PlusOutlined /> */}
            {t(`Settle`)}
          </Title>
        }
        open={show}
        onOk={() => this.formRef.current.submit()}
        onCancel={this.onCloseModal}
        width={600}
        style={{ top: 20 }}
        confirmLoading={submitting}
        maskClosable={false}
        okText={t("confirm")}
        cancelText={t("Cancel")}
      >
        {/* Main Detail */}
        <Spin
          spinning={submitting}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          <Form
            {...this.layout}
            ref={this.formRef}
            name="add-merchant-form"
            onFinish={this.onFinish}
            style={{ maxWidth: 600 }}
            validateMessages={validateMessages}
          >
            <Form.Item
              name={["merchant", "name"]}
              label={t("Merchant Name")}
              rules={[
                {
                  required: true,
                  message: t("Please input the merchant name!"),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["merchant", "withdrawalLimit"]}
              label={t("withdrawal Limit")}
              rules={[
                {
                  required: true,
                  min: 1,
                  message: t("Please enter a valid Withdrawal Limit!"),
                },
              ]}
            >
              <Input type="number" min={1} />
            </Form.Item>
            <Form.Item
              name={["merchant", "depositCallbackUrl"]}
              label={t("Deposit CallbackUrl")}
              rules={[
                {
                  required: true,
                  type: "url",
                  message: t("Please enter a valid Deposit Callback Url!"),
                },
              ]}
            >
              <Input type="url" defaultValue={"https://"} />
            </Form.Item>
            <Form.Item
              name={["merchant", "withdrawalCallbackUrl"]}
              label={t("Withdrawal CallbackUrl")}
              rules={[
                {
                  required: true,
                  type: "url",
                  message: t("Please enter a valid Withdrawal Callback Url!"),
                },
              ]}
            >
              <Input type="url" defaultValue={"https://"} />
            </Form.Item>
          </Form>
        </Spin>
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************** End of ModelSettle **************

// ************** Start of SetFeesModel **************
export class SetFeesModel extends Component {
  formRef = React.createRef();
  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  state = {
    loading: false,
    disabled: true,
    submitting: false,
  };

  openNotification = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };
  onChangeSettingFee = (values) => {
    let defaultValue = values?.target?.defaultValue;
    let targetValue = values?.target?.value;
    this.setState({ disabled: defaultValue === targetValue });
  };
  onFeeSettingFinish = (values) => {
    const { isData, getAllDataMerchang, t } = this.props;

    if (!isData?.FeeSetting?.id) {
      this.openNotification(
        "error",
        "เกิดข้อผิดพลาด",
        "ไม่พบข้อมูล Setting ID",
      );
      return;
    }
    let { depositFee, withdrawalFee, verifyAccountFee, deposit_fee_slep } =
      values;
    this.setState({ submitting: true, loading: true });
    let feeDep = parseFloat(
      depositFee || isData?.FeeSetting?.depositFeePercentage || 0,
    );
    let feeWit = parseFloat(
      withdrawalFee || isData?.FeeSetting?.withdrawalFeePercentage || 0,
    );
    let feeverifyAcc = parseFloat(
      verifyAccountFee || isData?.FeeSetting?.verifyAccountFee || 0,
    );

    let depositFeeSlep = parseFloat(
      deposit_fee_slep || isData?.FeeSetting?.deposit_fee_slep || 0,
    );
    let item = {
      FeeSetting_id: isData?.FeeSetting?.id,
      merchantId: isData?.id,
      depositFeePercentage: feeDep,
      withdrawalFeePercentage: feeWit,
      deposit_fee_slep: depositFeeSlep,
      verifyAccountFee: feeverifyAcc,
    };
    try {
      Apisetting.setFees(item)
        .then((res) => {
          if (res.data.success) {
            getAllDataMerchang();
            this.openNotification("success", t("สำเร็จ"), t(res.data.message));
            setTimeout(() => {
              this.onCloseModal();
            }, 300);
          } else {
            this.openNotification("error", "เกิดข้อผิดพลาด", res.data.message);
          }
        })
        .catch((err) => {
          this.openNotification(
            "error",
            "Error Status Code : " + err.status,
            err.message,
          );
          console.log(err.message);
        });
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        this.setState({
          loading: false,
          submitting: false,
        });
      }, 1500);
    }
  };
  onCloseModal = () => {
    const { handleClose } = this.props;
    this.setState(
      {
        loading: false,
        submitting: false,
      },
      () => handleClose(),
    );
    // this.formRef.current.resetFields();
  };
  render() {
    const { show, t, isData } = this.props;
    const { submitting, loading } = this.state;
    // console.log(isData.name)
    if (!show) {
      return "";
    }

    return (
      <Modal
        maskClosable={false}
        title={
          <h5 className="mb-4">
            {/* <PlusOutlined /> */}
            {t(`Setting`)}
          </h5>
        }
        open={show}
        onOk={() => this.formRef.current.submit()}
        onCancel={this.onCloseModal}
        width={500}
        style={{ top: 20 }}
        confirmLoading={submitting}
        okText={t(submitting ? "loading..." : "confirm")}
        cancelText={t("Cancel")}
      >
        {/* Main Detail */}
        <Spin
          spinning={submitting}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        >
          <div>
            <p className="mb-1" style={{ textTransform: "capitalize" }}>
              <span style={{ fontWeight: "500", textTransform: "capitalize" }}>
                {t("Merchant")} :
              </span>{" "}
              {isData.name}
            </p>
            <p>
              <span style={{ fontWeight: "500" }}>{t("Status")} :</span>{" "}
              <Tag color={tagsBageStatus(isData.isActive ? 1 : 0)}>
                {isData.isActive ? "Active" : "Inactive"}
              </Tag>
            </p>
          </div>

          {CheckPermission("setFees") && (
            <Form
              ref={this.formRef}
              layout="vertical"
              name="add-merchant-form"
              onFinish={this.onFeeSettingFinish}
              initialValues={{
                depositFee: Intl.NumberFormat().format(
                  parseFloat(
                    isData?.FeeSetting?.depositFeePercentage || 0,
                  ).toFixed(2),
                ),
                withdrawalFee: Intl.NumberFormat().format(
                  parseFloat(
                    isData?.FeeSetting?.withdrawalFeePercentage || 0,
                  ).toFixed(2),
                ),
                deposit_fee_slep: Intl.NumberFormat().format(
                  parseFloat(isData?.FeeSetting?.deposit_fee_slep || 0).toFixed(
                    2,
                  ),
                ),
                verifyAccountFee: Intl.NumberFormat().format(
                  parseFloat(isData?.FeeSetting?.verifyAccountFee || 0).toFixed(
                    2,
                  ),
                ),
              }}
            >
              {/* <Form.Item label=""></Form.Item> */}
              <>
                <label>{t("ตั้งค่าค่าธรรมเนียม")}</label>
                <Form.Item
                  label={t("ค่าธรรมเนียม ฝากเงิน")}
                  tooltip={{
                    title: t("ค่าธรรมเนียม ฝากเงิน"),
                    icon: <QuestionCircleTwoTone />,
                  }}
                  name="depositFee"
                  rules={[
                    {
                      required: false,
                      message: t("กรุณากรอกค่าธรรมเนียมฝากเงิน!"),
                      transform: (value) => Number(value),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={t("ตั้งค่า ค่าธรรมเนียมฝากเงิน เช่น 0.1")}
                    addonBefore={`%`}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item
                  label={t("ค่าธรรมเนียม ถอนเงิน")}
                  tooltip={{
                    title: t("ค่าธรรมเนียม ถอนเงิน"),
                    icon: <QuestionCircleTwoTone />,
                  }}
                  name="withdrawalFee"
                  rules={[
                    {
                      required: false,
                      message: t("กรุณากรอกค่าธรรมเนียมการถอน!"),
                      transform: (value) => Number(value),
                    },
                  ]}
                >
                  <InputNumber
                    disabled={loading}
                    placeholder={t("ตั้งค่า ค่าธรรมเนียมถอนเงิน เช่น 0.1")}
                    style={{ width: "100%" }}
                    addonBefore={`%`}
                    onChange={this.onChangeSettingFee}
                  />
                </Form.Item>

                <Form.Item
                  label={t("ค่าธรรมเนียม Verify Slip")}
                  tooltip={{
                    title: t(
                      "ค่าธรรมเนียม Verify Slip แบบมี QRcode และ ไม่มี QRcode",
                    ),
                    icon: <QuestionCircleTwoTone />,
                  }}
                  name="deposit_fee_slep"
                  rules={[
                    {
                      required: false,
                      message: t("กรุณากรอกค่าธรรมเนียม Verify Slip !"),
                      transform: (value) => Number(value),
                    },
                  ]}
                >
                  <InputNumber
                    disabled={loading}
                    placeholder={t("ตั้งค่า ค่าธรรมเนียม Verify Slip เช่น 0.1")}
                    style={{ width: "100%" }}
                    addonBefore={`%`}
                    onChange={this.onChangeSettingFee}
                  />
                </Form.Item>
                <Form.Item
                  label={t("ค่าธรรมเนียม Verify Account")}
                  tooltip={{
                    title: t("ค่าธรรมเนียม Verify Account"),
                    icon: <QuestionCircleTwoTone />,
                  }}
                  name="verifyAccountFee"
                  rules={[
                    {
                      required: false,
                      message: t("กรุณากรอกค่าธรรมเนียม Verify Account !"),
                      transform: (value) => Number(value),
                    },
                  ]}
                >
                  <InputNumber
                    disabled={loading}
                    placeholder={t(
                      "ตั้งค่า ค่าธรรมเนียม Verify Account เช่น 0.1",
                    )}
                    style={{ width: "100%" }}
                    addonBefore={`%`}
                    onChange={this.onChangeSettingFee}
                  />
                </Form.Item>
              </>
            </Form>
          )}
        </Spin>
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************** End of SetFeesModel **************

// ************** Start of SetMinWithdrawDepositModel **************
export class SetMinWithdrawDepositModel extends Component {
  formRef = React.createRef();
  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  state = {
    loading: false,
    disabled: true,
    submitting: false,
  };

  openNotification = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };
  onChangeSettingFee = (values) => {
    let defaultValue = values.target.defaultValue;
    let targetValue = values.target.value;
    this.setState({ disabled: defaultValue === targetValue });
  };
  onFeeSettingFinish = (values) => {
    const { isData, getAllDataMerchang, t } = this.props;
    this.setState({ submitting: true, loading: true });
    let minDep =
      parseFloat(values.deposit_minlimit) || isData?.deposit_minlimit;
    let minWit =
      parseFloat(values.witdrow_minlimit) || isData?.witdrow_minlimit;
    // let maxWit = parseFloat(values.withdrawalLimit) || isData?.withdrawalLimit;
    let item = {
      merchantId: isData?.id,
      deposit_minlimit: minDep,
      witdrow_minlimit: minWit,
      // withdrawalLimit: maxWit,
      depositCallbackUrl: values.depositCallbackUrl,
      withdrawalCallbackUrl: values.withdrawalCallbackUrl,
      depositOnHoldCallbackUrl: values.depositOnHoldCallbackUrl,
    };

    try {
      Apisetting.get_set_min_withdraw_deposit(item)
        .then((res) => {
          if (res.data.success) {
            getAllDataMerchang();
            setTimeout(() => {
              this.openNotification(
                "success",
                t("สำเร็จ"),
                t(res.data.message),
              );
              this.onCloseModal();
            }, 1000);
          } else {
            this.openNotification("error", "เกิดข้อผิดพลาด", res.data.message);
          }
        })
        .catch((err) => {
          this.openNotification(
            "error",
            "Error Status Code : " + err.status,
            err.message,
          );
          console.log(err.message);
        });
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        this.setState({
          loading: false,
          submitting: false,
        });
      }, 1500);
    }
  };
  onCloseModal = () => {
    this.setState({
      loading: false,
      submitting: false,
    });
    this.props.handleClose();
  };
  render() {
    const { show, t, isData } = this.props;
    const { submitting, loading } = this.state;
    // console.log(isData.name)
    if (!show) {
      return "";
    }
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    };
    return (
      <Modal
        maskClosable={false}
        title={
          <h5 className="mb-4">
            {/* <PlusOutlined /> */}
            {t(`Setting`)}
          </h5>
        }
        open={show}
        onOk={() => this.formRef.current.submit()}
        onCancel={() => this.onCloseModal()}
        width={500}
        style={{ top: 20 }}
        confirmLoading={submitting}
        loading={submitting}
        okText={t(submitting ? "loading..." : "confirm")}
        cancelText={t("Cancel")}
      >
        {/* Main Detail */}

        <div>
          <p className="mb-1" style={{ textTransform: "capitalize" }}>
            <span style={{ fontWeight: "500", textTransform: "uppercase" }}>
              {t("Merchant")} :
            </span>{" "}
            {isData.name}
          </p>
          <p>
            <span style={{ fontWeight: "500", textTransform: "uppercase" }}>
              {t("Status")} :
            </span>{" "}
            <Tag
              color={tagsBageStatus(isData.isActive ? 1 : 0)}

            >
              {isData.isActive ? t("enabled") : t("disabled")}
            </Tag>
          </p>
        </div>

        <Form
          ref={this.formRef}
          {...formItemLayout}
          style={{ maxWidth: 600 }}
          name="add-merchant-form"
          onFinish={this.onFeeSettingFinish}
          variant={"filled"}
          initialValues={{
            withdrawalCallbackUrl:
              isData?.withdrawalCallbackUrl ||
              "https://YOUR_PAYOUT_CALLBACK_URL.com",
            depositCallbackUrl:
              isData?.depositCallbackUrl ||
              "https://YOUR_PAYIN_CALLBACK_URL.com",
            depositOnHoldCallbackUrl:
              isData?.depositOnHoldCallbackUrl ||
              "https://YOUR_OnHold_CALLBACK_URL.com",
            witdrow_minlimit:
              isData?.witdrow_minlimit === 0 ? "" : isData?.witdrow_minlimit,
            deposit_minlimit:
              isData?.deposit_minlimit === 0 ? "" : isData?.deposit_minlimit,
            // withdrawalLimit:
            //   isData?.withdrawalLimit === 0 ? "" : isData?.withdrawalLimit,
          }}
        >
          <Divider
            orientation="left"
            className="mb-2"
            style={{ marginLeft: "5px" }}
          >
            {t("Set min Payin and Payout amounts.")}
          </Divider>
          <Form.Item
            name="deposit_minlimit"
            style={{ textTransform: "uppercase" }}
            label={t("Min Payin")}
            rules={[
              {
                required: true,
                min: 1,
                message: t("กรุณากรอกข้อมูลฝากเงินขั้นต่ำ อย่างน้อย 1 บาท!"),
                transform: (value) => Number(value),
              },
            ]}
          >
            <Input
              disabled={loading}
              min={1}
              defaultValue={isData?.deposit_minlimit}
              placeholder={t("ใส่จำนวนเงินฝากขั้นต่ำ อย่างน้อย 1 บาท")}
              onChange={this.onChangeSettingFee}
            />
          </Form.Item>
          <Form.Item
            name="witdrow_minlimit"
            style={{ textTransform: "uppercase" }}
            label={t("Min Payout")}
            rules={[
              {
                required: true,
                message: t("กรุณากรอกข้อมูลถอนเงินเขั้นต่ำ อย่างน้อย 1 บาท!"),
                transform: (value) => Number(value),
              },
            ]}
          >
            <Input
              disabled={loading}
              defaultValue={isData?.witdrow_minlimit}
              placeholder={t("ใส่จำนวนเงินถอนเงินขั้นต่ำ อย่างน้อย 1 บาท")}
              onChange={this.onChangeSettingFee}
            />
          </Form.Item>

          <Divider orientation="left" style={{ textTransform: "uppercase" }}>
            {"Set Callback Url"}
          </Divider>

          <Form.Item
            style={{ textTransform: "uppercase" }}
            name={["depositCallbackUrl"]}
            label={t("DEP.")}
            rules={[
              {
                required: false,
                type: "url",
                message: t("Please enter a valid Deposit Callback Url!"),
              },
            ]}
          >
            <Input
              type="url"
              onChange={this.onChangeSettingFee}
              defaultValue={isData?.depositCallbackUrl}
              placeholder={"Enter Dep. Callback Url"}
            />
          </Form.Item>

          <Form.Item
            style={{ textTransform: "uppercase" }}
            name={["withdrawalCallbackUrl"]}
            label={t("WTH.")}
            rules={[
              {
                required: false,
                type: "url",
                message: t("Please enter a valid Withdrawal Callback Url!"),
              },
            ]}
          >
            <Input
              type="url"
              defaultValue={isData?.withdrawalCallbackUrl}
              placeholder={"Enter Wth. Callback Url"}
            />
          </Form.Item>
          <Form.Item
            label={t("OnHold")}
            style={{ textTransform: "uppercase" }}
            name={["depositOnHoldCallbackUrl"]}
            rules={[
              {
                required: false,
                type: "url",
                message: t("Please enter a valid Deposit OnHold Callback Url!"),
              },
            ]}
          >
            <Input
              type="url"
              defaultValue={isData?.depositOnHoldCallbackUrl}
              placeholder={"Enter OnHold Callback Url"}
            />
          </Form.Item>
        </Form>

        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>
            Version: {config.version}
          </small>
        </Divider>
      </Modal>
    );
  }
}
// ************** End of SetMinWithdrawDepositModel **************

// ************** Start of AddBankModel **************

export class AddBankModel extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitting: false,
      showPromptpay: false,
      accountGroupData: [],
      accountPlatformData: [],
      status_bank: "Inactive",
      status_promptpay_qr: "Inactive",
      checkBank: "",
      checkChannel: "",
      selectBank: "",
      accountLength: 0,
      channelData: [],
      accountType: undefined,
      notesTxt: null,
      changBank: false,
      showLoginQRComponent: false,
      showAddBankComponent: true,
      dataQR: null,
      isExpired: false, // จัดการสถานะการหมดเวลาของรหัส QR
      initialTimeLeft: StringTimeLeft(), // กำหนดเวลาหมดอายุเริ่มต้น (ตัวอย่าง: 5 นาที)
    };
    this.inputRef = React.createRef();
  }


  componentDidMount() {
    if (this.props.show) {
      this.getBankAccountGroup();
      this.getBankPlatform();
    }
  }

  // --- API Fetchers ---
  getBankAccountGroup = async () => {
    Api.getall_BankGrop()
      .then(res => res.data.success && this.setState({ accountGroupData: Array.isArray(res.data.data) ? res.data.data : [] }))
      .catch(err => this.openNotification("error", "Error", "Failed to fetch bank groups."));
  };

  getBankPlatform = async () => {
    Apibank.getdata_bankPlatform()
      .then(res => res.data.success && this.setState({ accountPlatformData: Array.isArray(res.data.data) ? res.data.data : [] }))
      .catch(err => this.openNotification("error", "Error", "Failed to fetch bank platforms."));
  };

  // --- Helpers ---
  openNotification = (type, message, description) => notification[type]({ message, description });

  checkInputChannel = async (data) => {
    return ValidChannels[data?.bank]?.includes(data?.channel) || false;
  };

  // --- Handlers ---
  handleConfirmSubmit = () => {
    const { t } = this.props;
    this.formRef.current.validateFields()
      .then(values => {
        confirm({
          title: t("Is the account information correct?"),
          content: t("Press 'Confirm' to proceed."),
          okText: t("Confirm"),
          cancelText: t("Cancel"),
          onOk: () => this.onFinish(values),
          onCancel: () => this.setState({ submitting: false }),
        });
      })
      .catch(() => this.openNotification("error", "Validation Error", "Please fill in all required fields."));
  };

  onFinish = async (values) => {
    const { getDataBankAccount, resProfileAdmin, isMerchantData, t, webHookUrl_wallet } = this.props;

    const { selectBank, checkChannel } = this.state;
    const mID = localStorage.getItem("selectedID");

    let webHookUrl = webHookUrl_wallet;

    let finalPayload = { ...values };
    let notesTxt = "";
    if (isNaN(values?.accountRefId) && checkChannel === "true-wallet") {
      finalPayload.accountRefId = webHookUrl;
    }

    let isCheck = true;
    if (selectBank === "gsb" && values?.accountType !== "withdrawal") {
      notesTxt = t("GSB only supports withdraw type");
      this.setState({ notesTxt: t("GSB only supports withdraw type") });
      isCheck = false;
    } else if (selectBank === "ttb" && values?.accountType !== "deposit") {
      notesTxt = t("TTB only supports deposit type");
      this.setState({ notesTxt: t("TTB only supports deposit type") });
      isCheck = false;
    }

    if (!isCheck) return this.openNotification("error", "Invalid Account Type", notesTxt);
    if (selectBank === "gsb") finalPayload.pin = "-";

    const payload = {
      ...finalPayload,
      merchantId: isMerchantData?.id || parseInt(mID),
      accountpay_Type: values?.accountType === "withdrawal" ? "" : "QR_PAY",
      accountNo: values?.accountNumber,
      bank: selectBank,
      is_verify_ip: false,
      bankAccountGroupId: 1,
      status_promptpay_qr: values?.accountType === "withdrawal" ? 1 : (values?.status_promptpay_qr === "Active" ? 1 : 0),
    };

    this.setState({ submitting: true });

    if (!(await this.checkInputChannel(payload))) {
      this.openNotification("error", "Failed", "Please select the correct channel.");
      return this.setState({ submitting: false });
    }

    const details = `เพิ่มบัญชี (${values?.accountType}) ${payload.bank} - ${values.accountNumber}`;
    const { id } = getCookie("validateMerchant") || {};

    try {
      const res = await Apisetting.postAddbankAcc(payload);
      let msgEn = "Error adding account.";
      let msgTh = "เกิดข้อผิดพลาดในการเพิ่มบัญชี";
      if (typeof res?.data?.message === "object") {
        msgEn = res?.data?.message?.en || msgEn;
        msgTh = res?.data?.message?.th || msgTh;
      } else if (typeof res?.data?.message === "string") {
        msgEn = res.data.message;
        msgTh = res.data.message;
      }
      if (res.data.success) {
        sendApiTelegram_activity(res, "Add bank account", details, resProfileAdmin);
        if (process.env.REACT_APP_ENV !== "staging" && CONFIGMERCHENTID.includes(id)) sendApiTelegram_activity_Support(res, "เพิ่มบัญชีธนาคาร", details, resProfileAdmin);
        setTimeout(() => {
          this.setState({ submitting: false }, () => getDataBankAccount());
        }, 1200);
        this.openNotification("success", msgEn, msgTh);

        if (res?.data?.data?.qrCode) {
          let qrData = res?.data?.data;
          let bankId = res?.data?.bankId;

          let isData = {
            ...qrData,
            bankId,
          };
          // เปิดหน้าจอ QR Component และล้างสถานะหมดอายุเก่าออกเพื่อเริ่มนับใหม่
          this.setState({
            showLoginQRComponent: true,
            showAddBankComponent: false,
            dataQR: isData,
            isExpired: false,
            initialTimeLeft: StringTimeLeft(),
          });
          return
        } else {
          this.onCloseModal()
        }

      } else {
        this.setState({ submitting: false });
        this.openNotification("error", msgEn, msgTh);
      }
    } catch (error) {
      let errorMsg = t("An error occurred while adding the account.");
      if (typeof error?.response?.data?.message === "object") {
        errorMsg = t(error.response.data.message.en);
      } else if (typeof error?.response?.data?.message === "string") {
        errorMsg = t(error.response.data.message);
      }
      sendApiTelegram_call_api_error(error, "Add bank account");
      this.openNotification("error", t("An error occurred"), errorMsg);
      this.setState({ submitting: false });
    }
  };

  onChangBank = (bank) => {
    const bankID = bank?.bank_id;
    if (!bankID) return;
    this.setState({ selectBank: bankID, accountLength: bank?.accountLength, checkBank: bankID, }, () => {
      this.updateChannels(bankID);
      this.onChangSelectAccountType("");
      this.formRef.current.setFieldsValue({
        accountNumber: undefined,
        channel: undefined,
        accountName: undefined,
        deviceId: undefined,
        pin: undefined,
        telephoneNumber: undefined,
        password: undefined,
        accountRefId: undefined,
        visitorId: undefined,
        visitorKey: undefined,
        accountType: undefined,
      });
    });
  };

  updateChannels = (bank) => this.setState({ channelData: ChannelsBank[bank] || [] });

  onFormValuesChange = (changed) => {
    if (changed.accountType) this.setState({ showPromptpay: changed.accountType === "deposit" });
    if (changed.channel) this.setState({ checkChannel: changed.channel });
  };

  onReset = () => {
    this.formRef.current?.resetFields();
    this.setState({ checkBank: "", selectBank: "", channelData: [], showPromptpay: false, accountType: "", notesTxt: null });
  };

  onCloseModal = () => {
    this.onReset();
    this.setState({
      submitting: false,
      notesTxt: null,
      showLoginQRComponent: false,
      showAddBankComponent: true,
      dataQR: null,
      isExpired: false,
      initialTimeLeft: StringTimeLeft(),
    });
    this.props.handleClose();
  };

  onChangSelectAccountType = (e) => {
    const { selectBank } = this.state;
    if ((selectBank === "gsb" && e !== "withdrawal") || (selectBank === "ttb" && e !== "deposit")) {
      const notesTxt = selectBank === "gsb" ? "GSB only supports withdraw type" : "TTB only supports deposit type";
      this.setState({ accountType: e, notesTxt });
      return;
    }
    this.setState({ accountType: e, notesTxt: null });
  };

  setStateShowModelQR = (state) => this.setState({ showLoginQRComponent: state, loadingAccount: false });

  // ฟังก์ชันทำงานเมื่อเวลานับถอยหลังเหลือ 0 (หมดเวลา)
  handleCountdownFinish = () => {
    console.log("QR Code has expired.");
    this.setState({ isExpired: true });
  };

  handleFocus = (options) => {
    // ใน Class Component การเข้าถึง ref จะผ่าน .current
    if (options?.cursor === 'all' && this.inputRef.current) {
      this.inputRef.current?.focus(options);
    }
    if (options?.copyTxt) {
      CopyTextToClipboard(options?.copyTxt)
    }
  };
  render() {
    const { show, t, isMerchantData, getConfirmKbizLoginQR, URLIconKbiz, webHookUrl_wallet, ModelTrueWalletGuide } = this.props;
    const { status_bank, submitting, accountGroupData, selectBank, channelData, accountLength, checkBank, checkChannel, status_promptpay_qr, showPromptpay, accountType, notesTxt, showAddBankComponent, showLoginQRComponent, dataQR, isExpired, initialTimeLeft } = this.state;

    if (!show) return null;
    let icon = iconTypeBank(accountType);

    const isKtbBiz = checkBank === "ktb" && checkChannel === "ktb-business";
    const isTrueWallet = checkBank === "true" && checkChannel === "true-wallet";
    const isBay = checkBank === "bay" && checkChannel === "krungsribizonline";
    const currentConfig = itemFormConfig.find(item => item.formChannel === checkChannel);

    const sharedProps = {
      prefix: <><Avatar shape="square" size={18} src={icon}></Avatar></>
    };

    const options = TypeOptions(t, checkBank);

    let currentOption = options.filter(option => !option.disabled);

    let webHookUrl = webHookUrl_wallet;

    // เช็คกรณีปิดปุ่ม: ถ้าอยู่ในหน้าแสดงผล QR Code และมีสถานะหมดอายุ (isExpired = true) ให้ disabled ปุ่ม OK

    return (
      <Modal
        maskClosable={false}
        title={<Title level={5}>{showAddBankComponent ? t("Modal Add Bank Account") : ""}</Title>}
        open={show}
        // 🛠️ แก้ไขจุดครอบฟังก์ชันใน onOk เพื่อไม่ให้ API ฝั่ง Parent ทำงานตั้งแต่โหลดหน้าจอแรก
        onOk={showLoginQRComponent ? () => getConfirmKbizLoginQR(dataQR?.bankId) : this.handleConfirmSubmit}
        onCancel={this.onCloseModal}
        width={showAddBankComponent ? 635 : 555}
        confirmLoading={submitting}
        okText={t(submitting ? "loading..." : "Confirm")}
        cancelText={t("Cancel")}
        style={{ top: 20 }}
        zIndex={1000}
        okButtonProps={{
          disabled: isExpired && showLoginQRComponent // ปิดปุ่มเมื่อ QR Code หมดอายุ
        }}

        cancelButtonProps={{
          className: "h-10 rounded-lg"
        }}
      >
        <Spin spinning={submitting}>
          {/* Add bank account */}
          {showAddBankComponent && (
            <>
              <div className="mb-3">
                <code style={{ color: "#5A5A5A" }}><b>{t("merchant")}</b>: {isMerchantData?.name} ({isMerchantData?.id})</code>
              </div>

              <Form
                ref={this.formRef}
                layout="vertical"
                onFinish={this.onFinish}
                onValuesChange={this.onFormValuesChange}
                initialValues={{ bankAccountGroupId: "Bank Standard", status_bank, bank: selectBank || "Select", }}
              >
                <Row gutter={[12, 0]}>
                  <Col span={12}>
                    <Form.Item name="bank" label={t("Select Bank Account")} rules={[{ required: !selectBank, message: "Please select a bank!" }]}>
                      <BankSelector onChangBank={this.onChangBank} t={t} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="channel" label={t("Select Channel")} rules={[{ required: !checkChannel, message: "Please select a channel!" }]}>
                      <Select disabled={!selectBank} placeholder={t("Select")} options={channelData} />
                    </Form.Item>
                  </Col>

                  {/* ถ้าไม่ใช่ true-wallet ให้แสดง */}
                  {!isTrueWallet && (<>
                    <Col span={12}>
                      <Form.Item
                        name="accountNumber"
                        label={t("Account No.")}
                        // ตัดทุกตัวอักษรที่ไม่ใช่ตัวเลข 0-9 ออกทั้งหมด (รวมถึงช่องว่าง และ -)
                        normalize={(value) => (value ? value.replace(/[^0-9]/g, '') : value)}
                        dependencies={['accountNumber']}
                        rules={[
                          { required: true, message: t('Please enter only numbers (0-9), no spaces or special characters.') },
                          { pattern: /^[0-9]+$/, message: t('Please enter only numbers (0-9)!') },
                          { min: accountLength, message: t("Account number must be at least {{length}} digits", { length: accountLength }) },
                          { max: 15, message: t("Account number cannot exceed 15 digits") },
                        ]}
                      >
                        <Input
                          disabled={!selectBank}
                          placeholder={t("Enter numbers only (0-9), no spaces")}
                          onKeyDown={(e) => { if (e.key === " ") e.preventDefault(); }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="accountName" label={t("Account Name")} dependencies={['accountName']} rules={[({ getFieldValue }) => (!getFieldValue('accountName') ? { required: true, message: t("Please enter account name") } : {}),]}>
                        <Input placeholder={t("Enter account name")} disabled={!selectBank} />
                      </Form.Item>
                    </Col>
                  </>)}


                  <Col span={12}>
                    <Form.Item className={notesTxt ? "mb-0" : ''} name="accountType" label={t("Select Account Type")} rules={[{ required: !accountType }]}>
                      <Select
                        {...sharedProps}
                        placeholder={t("Select")}
                        onChange={this.onChangSelectAccountType}
                        options={currentOption}
                        disabled={!this.state.selectBank}
                      />
                    </Form.Item>
                    {notesTxt && <div className="mt-2" style={{ fontSize: "11px", color: "red", marginBottom: 24 }}><u>{t(notesTxt)}.</u></div>}
                  </Col>
                  <Col span={12}>
                    <Form.Item name="bankAccountGroupId" label={t("Bank Group")} rules={[{ required: false }]}>
                      <Select disabled options={accountGroupData.map(d => ({ value: d.id, label: d.name }))} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item name="telephoneNumber" label={t("Telephone Number")} dependencies={['telephoneNumber']} rules={[({ getFieldValue }) => (!getFieldValue('telephoneNumber') ? { required: true, message: t("Please enter telephone") } : {}),]}>
                      <Input placeholder={t("Enter Telephone No.")} disabled={!selectBank} />
                    </Form.Item>
                  </Col>
                  {(isTrueWallet && currentConfig?.note) && (
                    <Col span={12}>
                      <Form.Item tooltip={{ title: t(`tooltip_Webhook_API`) }} rules={[{ required: false }]} className="mb-0" name="accountRefId" label={"Webhook URL"} >
                        <Input
                          className="d-block"
                          defaultValue={webHookUrl}
                          readOnly
                          title={webHookUrl}
                          style={{ cursor: "copy" }}
                          ref={this.inputRef}
                          onClick={() =>
                            this.handleFocus({ cursor: 'all', copyTxt: webHookUrl })
                          }
                        />
                      </Form.Item>
                    </Col>
                  )}

                  {currentConfig?.fields.map((field, index) => (
                    <Col span={field.span} key={`${field.name}-${index}`}>
                      <Form.Item
                        key={`${checkChannel}-${field.name}-${index}`}
                        name={field.name}
                        label={field?.label}
                        tooltip={field.tooltip ? { title: t(field.tooltip) } : null}
                        dependencies={[field.name]}
                        style={{ display: (accountType === "deposit" && field.name === "pushToken") ? "none" : "block" }}
                        rules={[({ getFieldValue }) => (!getFieldValue(field.name) ? { required: (accountType === "deposit" && field.name === "pushToken") ? false : field.require, message: t(`Please enter ${field.label}!`) } : {}),]}
                      >
                        {field.type === "password" ? (
                          <Input.Password placeholder={t(`Enter `, { label: t(field.label) })} disabled={!selectBank || submitting} />
                        ) : (
                          <Input placeholder={t(`Enter `, { label: t(field.label) })} defaultValue={field?.defaultValue} disabled={!selectBank || submitting} />
                        )}
                      </Form.Item>
                    </Col>
                  ))}



                  {accountType === "withdrawal" && (
                    <Col span={12}>
                      <Form.Item rules={[{ required: false }]} className="mb-0" tooltip={{ title: "สามารถแก้ไขได้ในภายหลัง" }} name="limit_Left" label={"Limit left (Optional)"} >
                        <Input placeholder="Enter Limit left Ex. 1xxxxxx" disabled={!selectBank} />
                      </Form.Item>
                      <p className="mt-2" style={{ marginBottom: 24, color: "red", fontSize: 11 }}>*{t("กรุณาใส่ข้อมูลจริงตามวงเงินที่แสดงในแอพหรือเว็ปไซต์")}</p>
                    </Col>
                  )}
                </Row>

                {isKtbBiz && showPromptpay && (
                  <Form.Item label={t("Status Prompt pay")} name="status_promptpay_qr">
                    <Radio.Group defaultValue={status_promptpay_qr}>
                      <Radio value="Inactive">{t("Inactive")}</Radio>
                      <Radio value="Active">{t("Active")}</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}

                <Form.Item label={t("Status Account")} name="status_bank">
                  <Radio.Group>
                    <Radio value="Inactive">{t("Inactive")}</Radio>
                    <Radio value="Active">{t("Active")}</Radio>
                  </Radio.Group>
                </Form.Item>

                {/* Path หมายเหตุ */}
                {/* true-wallet */}
                {(isTrueWallet && currentConfig?.note) && (<>
                  <Alert className="mb-0" showIcon icon={<BulbOutlined size={24} />} type="info" action={<Button size="small" type="link" onClick={() => ModelTrueWalletGuide()}> {t(currentConfig?.action)}</Button>} message={t(currentConfig?.note)}></Alert>
                </>)}

                {/* กรุงศรี */}
                {(isBay && currentConfig?.note) && (<>
                  <Alert className="mb-0" showIcon icon={<BulbOutlined size={24} />} type="warning" action={<Button size="small" type="link" onClick={() => window.open("/pushbullet-guide", "_blank", "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=567, height=700")}> {t(currentConfig?.action)}</Button>} message={t(currentConfig?.note)}></Alert>
                </>)}
              </Form>
            </>
          )}

          {/* QR Code Component Section */}
          {showLoginQRComponent && (
            <LoginQRComponent
              data={dataQR}
              qrValue={dataQR?.qrCode} // ส่งค่า String ของรหัส QR ไปให้ตัวลูกแสดงผล
              initialTimeLeft={initialTimeLeft} // ส่งค่ารูปแบบสตริงเวลาชุดใหญ่ "1779094369243" ไปให้ Countdown ประมวลผล
              isExpired={isExpired}
              handleCountdownFinish={this.handleCountdownFinish}
              onRefreshQr={() => this.onFinish(this.formRef.current.getFieldsValue())} // ผูกฟังก์ชันรีเฟรชรหัสกลับมาขอ API เพิ่มเติม
              URLIconKbiz={URLIconKbiz}
              t={t}
            />
          )}
        </Spin>
        <Divider orientation="center">
          <small style={{ fontSize: "11px", color: "#888" }}>Version: {config.version}</small>
        </Divider>
      </Modal>
    );
  }
}
// ************** End of AddBankModel **************


export class LoginQRCodeCard extends Component {


  handleRefreshCode = () => {
    if (this.props.onRefreshQr) {
      this.props.onRefreshQr();
    }
  };

  handleConfirmSubmit = () => {
    if (this.props.onConfirm) this.props.onConfirm();
  };

  onCloseModal = () => {
    if (this.props.setStateShowModelQR) this.props.setStateShowModelQR(false);
  };

  render() {
    // ดึง URLIconKbiz ออกมาจาก props เพื่อพร้อมนำไปใช้ใน QRCode
    const { show, t, loading, showBTNconfirmQR, isExpired, handleCountdownFinish, data, initialTimeLeft } = this.props;

    if (!show) {
      return null;
    }

    const stylesObject = {
      root: {
        border: '2px solid #10b981',
        borderRadius: 16,
        padding: 14,
      },
    };

    let { qrCode } = data || {};

    const sharedProps = {
      src: qrCode,
      width: 160,
      alt: 'QRcode',
      preview: !isExpired,
    };

    return (
      <Modal
        maskClosable={false}
        title={<Title level={5} className="m-0 d-none">{t("Confirm access")}</Title>}
        open={show}
        onOk={() => this.handleConfirmSubmit()}
        onCancel={this.onCloseModal}
        width={555}
        confirmLoading={loading}
        okText={t(loading ? "loading..." : "Confirm")}
        cancelText={t("Cancel")}
        style={{ top: 20 }}
        okButtonProps={{
          className: `bg-emerald-600 hover:bg-emerald-700 border-none text-white font-medium px-6 h-10 rounded-lg ${!showBTNconfirmQR ? "d-none" : ""}`,
          disabled: isExpired
        }}
        cancelButtonProps={{
          className: "h-10 rounded-lg"
        }}
      >
        <Spin spinning={loading}>
          <div className="flex flex-col items-center text-center p-4 pt-6">
            <Section1 t={t} />
            <div className="d-flex justify-center p-3 rounded-2xl mb-6">
              <Image {...sharedProps} style={{
                ...stylesObject.root,
                filter: isExpired ? 'blur(6px)' : 'none',

                transition: 'filter 0.3s ease'
              }} />
            </div>

            {/* ส่วนจัดระเบียบตัวนับถอยหลังด้วย Tailwind CSS */}
            <div className="mb-6 h-12 flex justify-center items-center">
              {!isExpired ? (
                <div className="flex items-center gap-1 text-sm text-gray-500">
                  <Section3 t={t} />

                  <Timer
                    value={parseInt(initialTimeLeft)}
                    type="countdown"
                    onFinish={handleCountdownFinish}
                    valueStyle={{ fontSize: '14px', color: '#10b981', fontWeight: '600', display: 'inline-block' }}
                  />
                </div>
              ) : (
                <Section4 t={t} />
              )}
            </div>

            <div className="mt-3 w-full bg-gray-50 rounded-xl p-3 border border-gray-100">
              <Section5 t={t} />
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
}


export class GenDeviceModel extends React.Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  // ปิด Modal และรีเซ็ตค่า
  onClose = () => {
    const { handleClose } = this.props;
    this.setState({ loading: false }, () => {
      if (this.formRef.current) {
        this.formRef.current.resetFields();
      }
      handleClose();
    });
  };

  // ฟังก์ชันเมื่อมีการพิมพ์ OTP
  handleOtpChange = (value) => {
    // ถ้ากรอกครบ 6 หลัก ให้สั่ง submit ฟอร์มทันที
    if (value.length === 6) {
      this.formRef.current.submit();
    }
  };

  // ฟังก์ชันยืนยัน OTP (ทำงานเมื่อเรียก submit)
  onFinish = async (values) => {
    const { fetchData, isData, t } = this.props;
    const { loading } = this.state;

    // ป้องกันการส่งซ้ำหากกำลังโหลดอยู่
    if (loading) return;

    if (!isData?.refId) return alert("Missing RefId. Please try again.");

    // เตรียม Payload
    const payload = {
      otp: values.otp,
      refId: isData?.refId,
    };

    this.setState({ loading: true });

    try {
      const res = await Apibank.ktb_confirm_otp(payload);

      if (res.status === 200) {
        this.setState({ loading: false }, () => {
          this.onClose(); // ปิด Modal
          if (typeof fetchData === "function") fetchData(); // รีโหลดข้อมูลใหม่
        });
      }
    } catch (error) {
      console.error("OTP Confirmation Error:", error);
      const errTxt =
        error?.response?.data?.message ||
        error.message ||
        "เกิดข้อผิดพลาดในการยืนยัน OTP";
      const statusCode = error?.response?.status || error.status || "Unknown";
      this.setState({ loading: false });
      openNotification("error", `Error: ${statusCode}`, t(errTxt));
      // กรณี Error อาจจะสั่งเคลียร์ค่า OTP เพื่อให้กรอกใหม่ได้ง่ายขึ้น (Optional)
      this.formRef.current.setFieldsValue({ otp: '' });
    }
  };
  onFinishFailed = (errorInfo) => console.log("Validation Failed:", errorInfo);;

  render() {
    const { show, t, isData } = this.props;
    const { loading } = this.state;

    if (!show) return null;

    let bankCode = isData?.channel || isData?.bank?.bankCode || "Bank Account";

    return (
      <Modal
        maskClosable={false}
        title={
          <Title level={5} className="mb-4">
            {t(`เชื่อม device {{bank}}`, { bank: bankCode.toUpperCase() })}
          </Title>
        }
        open={show}
        onCancel={this.onClose}
        width={450}
        style={{ top: 20 }}
        footer={[<Button
          danger
          onClick={this.onClose}
          style={{ marginRight: 8 }}
          disabled={loading}
        >
          {t("cancel")}
        </Button>]}
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          name="gen_device_otp_form"
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          variant="filled"
        >
          {/* ส่วนแสดง RefId */}
          <Form.Item label="" name="refId">
            <span>
              <b>RefId:</b> {isData?.refId}
            </span>
          </Form.Item>

          {/* ส่วนกรอก OTP พร้อม Auto Submit */}
          <Form.Item
            label="OTP"
            name="otp"
            rules={[
              { required: true, message: t("กรุณากรอก OTP!") },
              { len: 6, message: t("กรุณากรอก OTP ให้ครบ 6 หลัก") },
            ]}
          >
            <Input.OTP
              onChange={this.handleOtpChange} // ตรวจสอบความยาวเพื่อส่งค่าทันที
              disabled={loading}
              placeholder={t("กรอก OTP")}
              variant="outlined"
              className="mt-2"
              size="large"
              length={6}
            />
          </Form.Item>

          <span
            className="d-block mb-4"
            style={{ color: "#888", fontSize: "12px" }}
          >
            {t("กรอกรหัส OTP ที่ระบบส่งไปยังเบอร์โทรศัพท์มือถือที่ลงทะเบียนไว้")}
          </span>
        </Form>
      </Modal>
    );
  }
}

// ************** End of AddBankModel **************

export class ModelPaymentVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.voucherRef = createRef();
  }

  // ฟังก์ชันสำหรับดาวน์โหลด PDF
  downloadPDF = () => {
    this.setState({ loading: true }, () => this.handleExportPDF());
  };

  handleExportPDF = async () => {
    try {
      const element = this.voucherRef.current;

      // ✅ Trick: บังคับความกว้างชั่วคราวเพื่อให้ PDF มีสัดส่วนคงที่ (A4 standard)
      const originalStyle = element.style.width;
      element.style.width = "794px"; // ประมาณความกว้าง A4 ในหน่วย px

      const canvas = await html2canvas(element, {
        scale: 2, // 2 กำลังดีสำหรับมือถือ (ไม่ไฟล์ใหญ่เกินไป)
        useCORS: true,
        backgroundColor: "#ffffff",
        windowWidth: 794, // บังคับ Viewport ของ html2canvas
      });

      // คืนค่าความกว้างเดิม
      element.style.width = originalStyle;

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(
        `PAYMENT_VOUCHER_${this.props.isData?.created_at || "Transaction"}.pdf`,
      );
    } catch (error) {
      console.error("Export PDF Error:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { isData, show, t, handleClose, title } = this.props;
    const { loading } = this.state;

    // ตรวจสอบว่ามีข้อมูลส่งมาหรือไม่
    if (!isData) {
      return null;
    }

    const data = isData;
    // Parse ข้อมูลธนาคารจาก JSON String อย่างปลอดภัย
    let titleVoucher = "deposit";
    let Slip = {};

    try {
      const settleSlip = FormatDataSettleSlip(data?.settleSlip);

      let bankInfo = data?.bank ? JSON.parse(data?.bank) : {};
      Slip = {
        note: `${settleSlip?.data?.message || data?.note || "-"}`,
        amount: settleSlip?.data?.amount || data?.amount || 0,
        netAmount: !titleVoucher
          ? settleSlip?.data?.netAmount
          : data?.transferAmount,
        rate: data?.rate || 0,
        fee: !titleVoucher ? settleSlip?.data?.transferFee : data?.fee,
        logUuid: data?.logUuid || "-",
        transactionDateTime:
          settleSlip?.data?.updatedDateTime || data?.created_at || "-",
        accountName:
          settleSlip?.data?.toAccountNameTh || bankInfo?.accountName || "-",
        accountNo: bankInfo?.accountNo || "-",
        bankCode: bankInfo?.bankCode || "-",
        settleCurrency: data?.settleCurrency || "THB",
      };
    } catch (e) {
      console.error("Parse Bank Info Error", e);
      alert("Error:", e);
    }

    // ข้อมูลสำหรับตาราง
    const dataSource = [
      {
        key: "1",
        description: Slip?.note,
        rate: Number(Slip.rate).toLocaleString(),
        amount: Number(Slip.amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
        }),
      },
    ];

    const columns = [
      { title: "#", dataIndex: "key", key: "key", width: 60 },
      { title: "DESCRIPTION", dataIndex: "description", key: "description" },
      {
        title: "RATE",
        dataIndex: "rate",
        key: "rate",
        align: "right",
      },
      { title: "AMOUNT", dataIndex: "amount", key: "amount", align: "right" },
    ];

    return (
      <Modal
        maskClosable={false}
        title={null}
        open={show}
        onCancel={handleClose}
        width={700}
        centered
        style={{ top: 0 }}
        footer={[
          <Button
            type="primary"
            shape="round"
            icon={<DownloadOutlined />}
            loading={loading}
            disabled={loading}
            onClick={this.downloadPDF}
            style={{ backgroundColor: "#00bcd4", borderColor: "#00bcd4" }}
          >
            {t("Export PDF")}
          </Button>,
          <Button
            shape="round"
            danger
            icon={<CloseOutlined />}
            disabled={loading}
            loading={loading}
            onClick={handleClose}
          >
            {t("close")}
          </Button>,
        ]}
      >
        <div style={{ overflowX: "auto" }}>
          {/* พื้นที่สำหรับใบ Voucher (ส่วนที่ถูก Capture เป็นภาพ) */}

          <Card
            ref={this.voucherRef}
            className="voucher-card"
            bordered={false}
            style={{
              width: "100%",
              maxWidth: "765px",
              margin: "0 auto",
              padding: "20px",
              boxShadow: "none",
            }}
          >
            {/* Header */}

            <Divider
              orientation="left"
              children="Payment Voucher"
              style={{
                color: "#2c3e50",
                marginBottom: 40,
                textTransform: "uppercase",
              }}
            />

            {/* From / To Section */}
            <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
              <Col xs={12} sm={12}>
                <Text level={5} type="secondary" strong>
                  FROM
                </Text>
                <div style={{ marginTop: 8 }}>
                  <Title
                    type="secondary"
                    style={{ fontSize: 12, color: "#0000008a" }}
                  >
                    {config.web_name}
                  </Title>
                </div>
              </Col>
              <Col xs={12} sm={12} style={{ textAlign: "right" }}>
                <Text level={5} type="secondary" strong>
                  {title === "deposit" ? <>{"BILL TO"}</> : "TO"}
                </Text>
                <div style={{ marginTop: 8 }}>
                  <Title
                    type="secondary"
                    style={{ fontSize: 12, color: "#0000008a" }}
                  >
                    {Slip?.accountName || "-"}
                  </Title>
                </div>
              </Col>
            </Row>

            {/* Receipt Info Section */}
            <Divider />
            <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
              <Col xs={12} sm={12}>
                <Text type="secondary" strong style={{ fontSize: 14 }}>
                  REFERENCE #
                </Text>
                <div style={{ marginTop: 8 }}>
                  <Text
                    type="secondary"
                    style={{ fontSize: 12, color: "#0000008a" }}
                  >
                    {Slip?.logUuid}
                  </Text>
                </div>
              </Col>
              <Col xs={12} sm={12} style={{ textAlign: "right" }}>
                <Text type="secondary" strong style={{ fontSize: 14 }}>
                  {"TRANSACTION DATE"}
                </Text>
                <div style={{ marginTop: 8, color: "#0000008a" }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {new Date(Slip?.transactionDateTime).toLocaleString(
                      "th-TH",
                      {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      },
                    )}
                  </Text>
                </div>
              </Col>
            </Row>

            <Divider />
            {/* Table Section */}
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              size="small"
              bordered
              scroll={{ x: 500 }} // ✅ ยอมให้เลื่อนในตารางได้ถ้าจอเล็กกว่า 500px
              style={{ marginBottom: 20 }}
            />

            {/* Summary Section */}
            <Row justify="end">
              <Col xs={24} sm={12} md={10}>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>SUB TOTAL</Text>
                  </Col>
                  <Col>
                    <Text>
                      {parseFloat(Slip?.amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>FEE</Text>
                  </Col>
                  <Col>
                    <Text>
                      {parseFloat(Slip?.fee).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </Text>
                  </Col>
                </Row>
                <Divider style={{ margin: "12px 0" }} />
                <Row justify="space-between" align="middle">
                  <Col>
                    <Title level={4} style={{ margin: 0 }}>
                      TOTAL
                    </Title>
                  </Col>
                  <Col style={{ textAlign: "right" }}>
                    <Title
                      level={4}
                      style={{
                        margin: 0,
                        color: "rgba(0,0,0,0.88)",
                        // borderBottom: "2px solid rgba(0,0,0,0.88)",
                      }}
                    >
                      {Slip?.settleCurrency}{" "}
                      {parseFloat(Slip?.netAmount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </Title>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Bank Note Footer */}
            <div
              style={{
                marginTop: 60,
                padding: "20px",
                background: "#f9f9f9",
                borderRadius: "8px",
                borderLeft: "4px solid #00bcd4",
              }}
            >
              <Text strong style={{ display: "block", marginBottom: 4 }}>
                BANK TRANSFER DETAILS
              </Text>
              <Text type="secondary">
                Bank Code: {Slip?.bankCode?.toUpperCase() || "-"} | No:{" "}
                {Slip?.accountNo || "-"}
              </Text>
            </div>
          </Card>
        </div>
      </Modal>
    );
  }
}
// ************** End of AddBankModel **************


// ************** EditDataModel **************
export class EditDataModel extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      tabKey: '1',
    };
  }

  // อัปเดตข้อมูลในฟอร์มเมื่อ props.isData มีการเปลี่ยนแปลง
  componentDidUpdate(prevProps) {
    if (this.props.isData !== prevProps.isData && this.props.isData) {
      this.formRef.current?.setFieldsValue({
        accountName: this.props.isData.accountName,
        accountNumber: this.props.isData.accountNumber,
        telephoneNumber: this.props.isData.telephoneNumber,
        note: this.props.isData.note,
      });
    }
  }

  // เมื่อกดปุ่ม OK ใน Modal ให้สั่ง submit form
  handleOk = async () => {
    if (this.formRef.current) {
      this.formRef.current.submit();
    }
  };

  // เมื่อ Form ผ่าน Validation จะวิ่งมาที่นี่
  handleSubmit = async (values) => {
    let { t, isData, resProfileAdmin, getDataBankAccount } = this.props;
    const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
      // ตรวจสอบว่ามีค่า (ไม่เป็นค่าว่าง, null หรือ undefined)
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});
    // 2. เช็คว่ามีการแก้ไขหรือไม่ โดยเทียบ filteredValues กับ isData
    // หมายเหตุ: ต้อง map key ให้ตรงกับโครงสร้าง isData ด้วย
    const isNoChange = Object.keys(filteredValues).every(key => {
      // แผนผังการเทียบ key (ถ้า key ใน form ไม่ตรงกับใน isData)
      const mapping = {
        companyId: isData?.company_id,
        visitorId: isData?.visitor_id,
        visitorKey: isData?.visitor_key,
        // ถ้าชื่อ key ตรงกันอยู่แล้ว เช่น username, note, deviceId
      };
      const originalValue = mapping[key] !== undefined ? mapping[key] : isData[key];
      return String(filteredValues[key]) === String(originalValue || "");
    });
    this.setState({ confirmLoading: true });

    if (isNoChange) {
      setTimeout(() => {
        this.handleCancel();
        this.setState({ confirmLoading: false });
        showToast("warning", t("ไม่มีการเปลี่ยนแปลงข้อมูล"));
      }, 1000);
      return
    }

    let payload = {
      ...filteredValues,
      edit_id: isData?.id,
      merchantId: isData?.merchantId,
      name: filteredValues?.accountName || isData?.accountName,
    }

    let changedName = isData?.accountName !== values?.accountName ? `~ ชื่อผู้ใช้: ${isData?.accountName} => ${values?.accountName}\n` : null;
    let changedAccountNumber = isData?.accountNumber !== values?.accountNumber ? `~ เลขบัญชี: ${isData?.accountNumber} => ${values?.accountNumber}\n` : null;
    let changedTelephoneNumber = isData?.telephoneNumber !== values?.telephoneNumber ? `~ เบอร์โทร: ${isData?.telephoneNumber} => ${values?.telephoneNumber}\n` : null;
    let changedNote = isData?.note !== values?.note ? `~ หมายเหตุ: ${isData?.note} => ${values?.note}\n` : null;

    // กรองเอาเฉพาะรายการที่มีการแก้ไข (ไม่เป็น null)
    let txtChange = [changedName, changedAccountNumber, changedTelephoneNumber, changedNote].filter(item => item !== null);

    // ใช้ .join('') เพื่อรวมข้อความเข้าด้วยกันโดยไม่มีเครื่องหมายจุลภาคคั่น
    // และใช้ .trim() ช่วยตัดช่องว่างหรือขึ้นบรรทัดใหม่ที่เกินมาด้านท้ายออก
    let details = `${t(`แก้ไขข้อมูลบัญชี${t(isData?.accountType)} (${this.state.tabKey === "1" ? t('ข้อมูลทั่วไป') : t('Advanced')})`)}:\n${txtChange.join('')}`.trim();

    const { id } = getCookie("validateMerchant") || {};


    try {

      let res = await Apibank.getEditDataBank(payload);
      sendApiTelegram_activity(
        res,
        "Edit Bank Account",
        details,
        resProfileAdmin,
      );
      if (res.status === 200) {
        if (process.env.REACT_APP_ENV !== "staging" && CONFIGMERCHENTID.includes(id)) sendApiTelegram_activity_Support(res, "แก้ไขข้อมูลบัญชี", details, resProfileAdmin);

        setTimeout(() => {
          this.setState({ confirmLoading: false }, () => {
            showToast("success", res.data?.message || "Data updated successfully!");
            this.handleCancel();
            getDataBankAccount()
          });
        }, 2000);
      } else {
        setTimeout(() => {
          this.setState({ confirmLoading: false }, () => {
            showToast("success", res.data?.message || "Data updat failed!");
          });
        }, 1000);
      }

    } catch (error) {
      console.error("Error submitting form:", error);
      this.setState({ confirmLoading: false });
      showToast("error", error?.message || "Error submitting form");
      sendApiTelegram_call_api_error(error, "[CATCH ERROR] Edit Bank Account");
    }
  };

  handleCancel = () => {
    this.props.handleClose();
    this.setState({ tabKey: "1" });
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  onChangeTabs = (key) => this.setState({ tabKey: key });

  render() {
    const { show, isData, t, canEditBank, canEditAdvancedBank } = this.props;
    const { confirmLoading, tabKey } = this.state;

    let showAdvancedTab = canEditAdvancedBank;

    // หากไม่มีข้อมูล ให้ return null เพื่อไม่ให้ React Error
    if (!show) return null;

    const items = [
      canEditBank && {
        key: '1',
        label: t('General'), // แนะนำให้ครอบ t() เพื่อรองรับหลายภาษา
        icon: <InfoCircleOutlined />,
        children: (
          <FormEditGeneralBankInfo
            formRef={this.formRef}
            handleSubmit={this.handleSubmit}
            isData={isData}
            confirmLoading={confirmLoading}
            t={t}
          />
        ),
      },
      showAdvancedTab && {
        key: '2',
        label: t('Advanced'),
        icon: <UserOutlined />,
        children: (
          <FormEditAdvancedBankInfo
            formRef={this.formRef}
            handleSubmit={this.handleSubmit}
            isData={isData}
            confirmLoading={confirmLoading}
            t={t}
          />
        ),
      },
    ].filter(Boolean); // <--- สำคัญมาก: กรองเอาเฉพาะ Object ที่มีค่าจริง
    return (
      <Modal
        title={t('Edit bank account information.')}
        open={show}
        onOk={this.handleOk} // เปลี่ยนมาเรียก handleOk ของ class
        onCancel={this.handleCancel}
        maskClosable={false}
        confirmLoading={confirmLoading}
        destroyOnClose // ช่วยเคลียร์ค่าใน Modal เมื่อปิด
        okText={t(confirmLoading ? "Saving data..." : "Save")}
        cancelText={t("Cancel")}
        style={{ top: 20 }}
      >
        <Divider />
        <Tabs defaultActiveKey={tabKey} items={items} onChange={this.onChangeTabs} />
        <Alert message={t("Enter information only in the fields that need to be edited.")} type="info" showIcon />
        <Divider orientation={"center"} children={<small style={{ color: "#888", fontSize: 10 }}>Version: {config.version}</small>} />
      </Modal>
    );
  }
}
// ************** End of EditDataModel **************
